const Variables = {
  APP_VERSION: process.env.REACT_APP_VERSION,
};

export default Variables;



// WEBPACK FOOTER //
// ./src/services/variables.ts